// extracted by mini-css-extract-plugin
export default {"actionCustom":"SpotlightCustom_actionCustom__F+R3G"};